<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area inquiry">
      <img
        :src="`${resources}img/img-top-sub-title7.jpg`"
        alt=""
        v-if="device === 'mo'"
      />
      <div class="tit_area">
        <div class="sub_tit">고객문의</div>
        <div class="sub_txt">
          한국오션플랫폼은 언제나 경청(傾聽)의 자세로<br />여러분의 소중한
          의견에 귀 기울이겠습니다.
        </div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents inquiry">
      <h3 class="h3_ty01">
        궁금하신 문의사항을 보내주시면<br />담당자가 최대한 신속하게 답변을
        해드리겠습니다.
      </h3>
      <div class="inquiry_form">
        <ValidationObserver ref="validFormRef" v-slot="{ reset }" slim>
          <form ref="formRef" @reset.prevent="reset">
            <fieldset>
              <legend>고객문의</legend>

              <ul class="form_inner">
                <ValidationProvider
                  name="category"
                  rules="required"
                  v-slot="{ classes }"
                  slim
                >
                  <li :class="classes">
                    <label for="select">문의 분류<em>*</em></label>
                    <div class="selectbox3 vselect">
                      <v-select
                        v-model="category"
                        :options="options"
                        :searchable="false"
                        placeholder="문의내역 선택"
                      >
                      </v-select>
                    </div>
                    <em class="txt_error">문의내역을 선택해 주세요.</em>
                  </li>
                </ValidationProvider>
                <ValidationProvider
                  name="name"
                  rules="required"
                  v-slot="{ classes }"
                  slim
                >
                  <li :class="classes">
                    <label for="c01">이름(회사) 입력<em>*</em></label>
                    <input
                      v-model="name"
                      id="c01"
                      type="text"
                      placeholder="이름(회사) 입력"
                    />
                    <em class="txt_error">이름(회사)를 입력해 주세요.</em>
                  </li>
                </ValidationProvider>
                <ValidationProvider
                  name="email"
                  rules="required|email"
                  v-slot="{ classes }"
                  slim
                >
                  <li :class="classes">
                    <label for="c02">이메일 주소<em>*</em></label>
                    <input
                      v-model="email"
                      id="c02"
                      type="email"
                      placeholder="이메일 주소 입력"
                    />
                    <em class="txt_error">이메일 주소를 입력해 주세요.</em>
                  </li>
                </ValidationProvider>
                <ValidationProvider
                  name="question"
                  rules="required"
                  v-slot="{ classes }"
                  slim
                >
                  <li :class="['txta_wrap', { ...classes }]">
                    <label for="c03">문의내용<em>*</em></label>
                    <textarea
                      v-model="question"
                      id="c03"
                      placeholder="내용을 입력해 주세요."
                    ></textarea>
                    <em class="txt_error">문의 내역을 입력해 주세요.</em>
                  </li>
                </ValidationProvider>
              </ul>
            </fieldset>
          </form>
          <div class="btn_send_wrap" v-if="device === 'mo'">
            <a href="#" class="btn_send" @click.prevent="onSend"> 문의하기</a>
          </div>
          <a href="#" class="btn_send" @click.prevent="onSend" v-else>
            문의하기</a
          >
        </ValidationObserver>
      </div>
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import page from '@/mixins/page';
import inquiry from '@/mixins/inquiry';

export default {
  mixins: [page, inquiry]
};
</script>

<style lang="scss"></style>
